import React, { Component } from "react";
import { Button, Icon } from "semantic-ui-react";

export class ViewDetailDelivery extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }
    handleOpenEdit = () => {
        console.log("open edit");
        console.log(this.props)
        this.props.agGridReact.props.getDeliveryDetails(this.props.data)
    };

    render() {
        return (
            <>
                <Button
                    onClick={this.handleOpenEdit}
                    disabled={this.props?.data?.status == 'Created' || this.props?.data?.status == 'Rejected' ? true : false}
                    basic
                    size="mini"
                    type="button"
                    icon
                >
                    {" "}
                    <img src="assets/img/delivery.svg" style={{ height: "15px" }} />
                </Button>
            </>
        );
    }
}

export default ViewDetailDelivery;
